import styled, { css } from 'styled-components';
import { Absolute, Box } from '@rsos/components/capstone/base';
import { withLayout } from '@rsos/components/capstone/base/Layout';
import { BP_LAPTOP } from '@rsos/constants/breakpoints';

export const FullWidthBox = styled(Box).attrs({
  grow: true,
  align: 'center',
  bg: 'background',
})`
  z-index: 0;
  ${({ isViewingAlerts }) => !isViewingAlerts && `width: 100%`};
`;

export const EventDetailsContainer = styled(Box).attrs({
  grow: true,
  horizontal: true,
})`
  ${({ isViewingAlerts }) => !isViewingAlerts && `width: 100%`};
  ${({ isIRP, selectedItem, isAllCallsSelected }) =>
    !isIRP &&
    (selectedItem || isAllCallsSelected) &&
    css`
      @media (max-width: ${BP_LAPTOP}px) {
        flex-direction: column-reverse;
      }
    `}
`;

export const MainContainer = withLayout(styled(Box).attrs({
  horizontal: true,
})`
  ${({ isIRP }) =>
    !isIRP &&
    css`
      @media (max-width: ${BP_LAPTOP}px) {
        flex-direction: column;
      }
      height: 100%;
    `}
  z-index: 0;
`);

export const SearchAndQueueContainer = styled(Box)`
  border-right: ${({ theme }) => `1px solid ${theme.colors.lightLineDivider}`};
  ${({ isIRP }) =>
    !isIRP &&
    css`
      @media (max-width: ${BP_LAPTOP}px) {
        width: 100%;
      }
    `}
`;

export const TextTo911Container = styled(Absolute).attrs({
  width: '400px',
  top: 10,
  left: 10,
  zIndex: 3,
})`
  ${css`
    @media (max-width: ${BP_LAPTOP}px) {
      left: 0;
      right: 0;
      margin: auto;
    }
  `}
`;
